import * as React from "react"
import { ThemeCss, Heading } from "gatsby-interface"
import { NarrowSingleColumn } from "@modules/ui/layouts/Containers"
import { useOrganizationNameFieldsFragment } from "@modules/organization/Settings/fragments.generated"
import { useOrganizationBaseDetailsQuery } from "@modules/organization/queries.generated"
import { createSite as text } from "@modules/locales/default.js"

export const headingCss: ThemeCss = theme => ({
  fontSize: theme.fontSizes[5],
  lineHeight: theme.lineHeights.dense,
  margin: 0,
  marginTop: theme.space[11],
  marginBottom: theme.space[3],

  span: {
    color: theme.colors.purple[50],
  },
})

export type SiteCreationWizardHeaderProps = {
  organizationId: string
}

export function SiteCreationWizardHeader({
  organizationId,
}: SiteCreationWizardHeaderProps) {
  const { data: cacheData } = useOrganizationNameFieldsFragment(organizationId)

  const { data: queryData } = useOrganizationBaseDetailsQuery({
    variables: { id: organizationId },
    skip: !!cacheData,
  })

  const workspaceName = cacheData
    ? cacheData.name
    : queryData?.organizationDetails?.name

  return (
    <Heading
      as="h1"
      css={(theme: Theme) => [headingCss(theme), { textAlign: "center" }]}
      variant="EMPHASIZED"
    >
      {text.headers.wizardTitle}

      {workspaceName && (
        <React.Fragment>
          {" "}
          to the <span>{workspaceName}</span> workspace
        </React.Fragment>
      )}
    </Heading>
  )
}
